exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".FiveBlockLinksForDriving-h2{text-align:center}.FiveBlockLinksForDriving-p{margin-bottom:3em}.FiveBlockLinksForDriving-list{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;border-width:1px;border-style:solid}.FiveBlockLinksForDriving-item{border-width:1px;border-style:solid none none;width:100%}.FiveBlockLinksForDriving-item:first-child{border-top-style:none}.FiveBlockLinksForDriving-a{display:block;padding:2em 0;line-height:1;font-weight:700;text-align:center}.FiveBlockLinksForDriving-a .fa{margin-right:.5em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/sass-loader/lib/loader.js!./src/components/contents/FiveBlockLinksForDriving/FiveBlockLinksForDriving.s.scss
// module id = 928
// module chunks = 26